import { AxiosResponse, AxiosError, isAxiosError } from 'axios';

/**
 * Type guard to check if a response is successful (has data)
 */
export function isSuccessResponse<T>(
  response: AxiosResponse<T> | AxiosError
): response is AxiosResponse<T> {
  return 'data' in response && response.status >= 200 && response.status < 300;
}

/**
 * Extract data from an axios response or return undefined if error
 * This is useful for optional chaining with the new hey-api client
 */
export function getData<T>(
  response: AxiosResponse<T> | AxiosError
): T | undefined {
  if (isSuccessResponse(response)) {
    return response.data;
  }
  return undefined;
}

/**
 * Extract data from axios response or throw if error
 * Use this in queryFn when you want errors to propagate
 */
export async function extractData<T>(
  response: Promise<AxiosResponse<T> | AxiosError>
): Promise<T> {
  const awaitedResponse = await response;
  if (isAxiosError(awaitedResponse)) {
    throw awaitedResponse;
  }
  return awaitedResponse.data;
}
